import React from "react";
import "../styles/Linkouts.scss";

const Linkouts: React.FC = () => {
  return (
    <div className="linkouts-container">
      <div className="linkout-head">DOWNLOAD DATA: </div>
      <a href="https://cmsny.org/health-indicators-by-immigration-legal-status-bronx/">
        Bronx
      </a>{" "}
      |{" "}
      <a
        href="https://cmsny.org/health-indicators-by-immigration-legal-status-brooklyn/"
        target="_blank"
      >
        Brooklyn
      </a>{" "}
      |{" "}
      <a
        href="https://cmsny.org/health-indicators-by-immigration-legal-status-manhattan/"
        target="_blank"
      >
        Manhattan
      </a>{" "}
      |{" "}
      <a
        href="https://cmsny.org/health-indicators-by-immigration-legal-status-queens/"
        target="_blank"
      >
        Queens
      </a>
    </div>
  );
};

export default Linkouts;
